import { MapPin, Tag, Star, Calendar, Image as ImageIcon } from "lucide-react";
import { useT } from "../../i18n/LanguageContext";

export default function Hero() {
  const { t } = useT();
  return (
    <section
      id="inicio"
      className="relative bg-noite text-[#faf6ee] overflow-hidden"
      data-testid="hero-section"
    >
      {/* Decorative gold halo */}
      <div className="absolute -top-40 left-1/4 w-[36rem] h-[36rem] rounded-full bg-[#e3b25b]/8 blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[32rem] h-[32rem] rounded-full bg-[#2c5fb5]/15 blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 pt-24 pb-28 md:pt-32 md:pb-40 relative">
        <div className="reveal max-w-3xl">
          <div className="inline-flex items-center gap-2 bg-transparent border border-[#e3b25b]/50 text-[#e3b25b] px-5 py-2 rounded-full text-[11px] font-semibold tracking-[0.22em] uppercase">
            <Star size={12} className="fill-[#e3b25b] text-[#e3b25b]" /> {t.hero.badge}
          </div>

          <h1 className="font-display text-6xl sm:text-7xl lg:text-8xl font-medium leading-[1] mt-10">
            {t.hero.title1}
            <br />
            <em className="text-[#e3b25b] font-normal">{t.hero.title2}</em>
          </h1>

          <p className="mt-8 text-lg sm:text-xl text-[#faf6ee]/85 leading-relaxed max-w-xl">
            {t.hero.subtitle}
            <br />
            {t.hero.subtitle2}
          </p>

          <p className="mt-10 flex items-center gap-2 text-sm text-[#faf6ee]/80">
            <MapPin size={16} className="text-[#d6532b]" />
            {t.hero.address}
          </p>

          <div className="mt-5 inline-flex items-center gap-2 bg-[#1a2c5c]/60 border border-[#e3b25b]/40 text-[#e3b25b] px-5 py-2.5 rounded-xl text-sm font-medium">
            <Tag size={14} /> {t.hero.pricetag}
          </div>

          <div className="mt-10 flex flex-wrap gap-4">
            <a href="#reserva" className="btn-primario" data-testid="hero-cta-reservar">
              <Calendar size={14} /> {t.hero.cta}
            </a>
            <a href="#galeria" className="btn-secundario" data-testid="hero-cta-galeria">
              <ImageIcon size={14} /> {t.hero.gallery}
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-[#faf6ee]/40 text-[10px] tracking-[0.4em] uppercase flex flex-col items-center gap-2">
        <span>scroll</span>
        <span className="w-px h-8 bg-[#faf6ee]/30" />
      </div>
      <div className="azulejo-band" aria-hidden="true" />
    </section>
  );
}
